<div class="offer-item">
  <div class="offer-image-content"
       [ngStyle]="{'background-image': 'url(' + offer_attributes.image + ')'}">
  </div>

  <div class="offer-description">
    <h3 class="offer-title">{{offer_attributes.application_name}}
      <span *ngIf="offer.application_slug !== 'allya'"
            class="offer-tag offer-tag-{{ offer.allya_offer ? 'orange' : 'grey' }}">
      Proposta {{ offer.allya_offer ? 'allya' : 'personalizada' }}
    </span>
    </h3>

    <p>{{ offer_attributes.description }}</p>

    <div class="offer-actions">

      <div class="only-input-check checkbox-nice">
        <input
          class="checkbox-nice"
          type="checkbox"
          [id]="'offer-participation-' + offer.application_slug"
          [checked]="isActive()"
          (change)="onChangeOfferState()">
        <label [htmlFor]="'offer-participation-' + offer.application_slug">Participando</label>
      </div>

      <button [routerLink]="['/negocio/proposta/', offer.application_slug]" [class.disabled]="!isActive()"
              *ngIf="!confirmation" class="btn btn-edit">Editar Proposta
      </button>
      <button [class.disabled]="loading" *ngIf="confirmation" (click)="confirmStateChange()" class="btn btn-confirm">
        Confirmar
      </button>

    </div>
  </div>
</div>
